import { render, staticRenderFns } from "./AccountsCreateEdit.vue?vue&type=template&id=368d0eb0&"
import script from "./AccountsCreateEdit.vue?vue&type=script&lang=js&"
export * from "./AccountsCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./AccountsCreateEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports